import moment from "moment";
export default {
	getProductosListado(state, getters, rootState) {
		const cats = state.categorias;
		const imps = rootState.impuestos.impuestosArray;
		var res = state.productos.map((e) => {
			let cFound = cats.find((c) => c.id == e.categoria);
			let iFound = imps.find((c) => c.id == e.impuesto);
			e.categoriaNombre = cFound
				? cFound.nombre
				: "Categoría sin definir";
			e.impuestoNombre = iFound ? iFound.nombre : "Impuesto sin definir";
			return e;
		});
		return res.sort((a, b) => {
			if (a.categoriaNombre == b.categoriaNombre) {
				return a.nombre > b.nombre ? 1 : -1;
			} else {
				return a.categoriaNombre > b.categoriaNombre ? 1 : -1;
			}
		});
	},
	getPedidosListadoRestaurante(state, getters, rootState) {
		const peds = state.pedidos;
		const rests = rootState.app.restauranteGest;
		return peds.filter((p) => rests.include(p.restaurante));
	},
	getPedidosInternosNegocio(state, getters, rootState) {
		const peds = state.pedidos;
		const estados = state.estados;
		var res = [];
		peds.filter((p) => p.estado != "realizando").forEach((e) => {
			let fechaEspera = e.fechaEspera;
			let fechaEnviado = e.fechaEnviado;
			let aux = JSON.parse(JSON.stringify(e));
			aux.fechaEspera = fechaEspera
				? moment(fechaEspera.toDate()).format("DD-MM-YYYY H:mm")
				: "";
			aux.fechaEnviado = fechaEnviado
				? moment(fechaEnviado.toDate()).format("DD-MM-YYYY HH:mm")
				: "-";
			let found = estados.find((s) => s.value == e.estado);
			if (found) {
				aux.estado = found;
			}
			res.push(aux);
		});
		return res;
	},
};
